module.exports = __webpack_public_path__ + "static/media/Entreprise-Renovation-Vaud.a60ce17e.jpg";